import { useQuery } from './use-query';
import { AppSettings } from '../features/settings/types/app-settings';
import { Language } from '../features/internationalization/types/language';

const defaultLanguage = 'en-US';
export const useDefaultLanguage = (): string => {
  const languages = useQuery<Language[]>({ path: '/languages/all', options: { keepPreviousData: true } });
  const appSettings = useQuery<AppSettings>({ path: '/appsettings', options: { keepPreviousData: true } });
  return languages.data?.find(language => language.id === appSettings.data?.defaultLang)?.code || defaultLanguage;
};
